export default {
  no_results: {
    title: 'No results for "{{search}}"',
    desc: 'Sorry, we couldn’t find a match. Please try a different search term.',
  },
  empty_menu: {
    title: 'No items available yet',
    desc: 'This menu doesn’t have anything to show right now. Please check back soon.',
  },
};
